<template>
    <div class="container">
        <div class="row align-items-center justify-content-center" style="min-height: 100vh">
            <div class="col-12 col-sm-auto" style="max-width: 500px">

                <div class="card bg-transparent pt-5 pb-5 text-center">

                    <div class="card-body ">
                        <img class="icon mb-3" src="../assets/images/success.png">

                        <div class="mb-3">
                            ยืนยันตัวตนสำเร็จ
                        </div>

                        <div class="mb-4">
                           ทำการยืนยันตัวตนแบบ<br> 2 ขั้นตอนเรียบร้อยแล้ว
                        </div>

                    </div>


                </div>

            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'Verify',
        components: {},
        data() {
            return {
                progress: 0
            }
        },
        created() {
            let progress = setInterval(() => {
                this.progress += 2;
            }, 100);

            setTimeout(() => {
                clearInterval(progress);
                window.location.href = "https://mket-2fa.stockradars.co/open_app";
            }, 5000);
        }


    }
</script>


<style lang="scss">
    @import "../assets/css/colors";

    .icon {
        max-height: 100px;
    }

    .otp-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .otp-input {
        width: 40px;
        height: 40px;
        padding: 5px;
        margin: 0 5px;
        font-size: 28px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        text-align: center;
        background-color: $black;
        color: $white;

        &.error {
            border: 1px solid red !important;
        }
    }

    .otp-input::-webkit-inner-spin-button,
    .otp-input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>
